// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import { ChangeEventTypeFragmentDoc, PotentialOperationDetailsFragmentDoc } from '../../../queries/fragments.generated';
import { AllocateProjectItemsFragmentDoc } from '../../../components/AllocateItemsTaskModal.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ChangeEventPageQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type ChangeEventPageQuery = { __typename?: 'Query', changeEvent: { __typename?: 'ChangeEvent', canCreateFinalEstimate: boolean, identifier: number, isReadyHomeManaged: boolean, budgetImpactInCents: number, totalCostInCents: number, status: Types.ChangeEventStatus, title: string, id: string, name: string, canSubmitForApproval: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, type: { __typename?: 'ChangeEventTypeDetail', code: Types.ChangeEventType, name: string }, lineItems: Array<{ __typename?: 'ChangeEventLineItem', id: string, originalTradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined, projectItem: { __typename?: 'ProjectItem', id: string, displayName: string, totalCostInCents: number, task?: { __typename?: 'Task', id: string, name: string, projectItems: Array<{ __typename?: 'ProjectItem', id: string }> } | null | undefined } }>, projectStage: { __typename?: 'ProjectStage', id: string, canCreateFinalEstimate: boolean, stage: { __typename?: 'StageDetail', code: Types.Stage }, project:
        | { __typename?: 'StandaloneProject', id: string, enableProductConfigPlan: boolean, features: Array<Types.ProjectFeature>, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
        | { __typename?: 'Region', id: string, enableProductConfigPlan: boolean, features: Array<Types.ProjectFeature>, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
        | { __typename?: 'Market', id: string, enableProductConfigPlan: boolean, features: Array<Types.ProjectFeature>, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
        | { __typename?: 'Community', id: string, enableProductConfigPlan: boolean, features: Array<Types.ProjectFeature>, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
        | { __typename?: 'Subdivision', id: string, enableProductConfigPlan: boolean, features: Array<Types.ProjectFeature>, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
        | { __typename?: 'Lot', id: string, enableProductConfigPlan: boolean, features: Array<Types.ProjectFeature>, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
        | { __typename?: 'Structure', id: string, enableProductConfigPlan: boolean, features: Array<Types.ProjectFeature>, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
        | { __typename?: 'Unit', id: string, enableProductConfigPlan: boolean, features: Array<Types.ProjectFeature>, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
       }, commitments: Array<
      | { __typename?: 'Commitment', id: string, accountingNumber: number, status: Types.CommitmentStatus, pandaDoc?: { __typename?: 'PandaDoc', id: string, externalPandaDocUrl?: string | null | undefined, status: Types.PandaDocStatus } | null | undefined }
      | { __typename?: 'CommitmentChangeOrder', id: string, accountingNumber: number, status: Types.CommitmentStatus, pandaDoc?: { __typename?: 'PandaDoc', id: string, externalPandaDocUrl?: string | null | undefined, status: Types.PandaDocStatus } | null | undefined }
    >, approval?: { __typename?: 'Approval', id: string } | null | undefined, tradesToDraftCommitmentsFor: Array<{ __typename?: 'TradePartner', id: string, name: string }>, pandaDoc?: { __typename?: 'PandaDoc', id: string, externalPandaDocUrl?: string | null | undefined } | null | undefined, createdBy?:
      | { __typename?: 'Bill', id: string, name: string }
      | { __typename?: 'Expense', id: string }
     | null | undefined } };

export type DeleteChangeEventMutationVariables = Types.Exact<{
  input: Types.DeleteChangeEventInput;
}>;


export type DeleteChangeEventMutation = { __typename?: 'Mutation', deleteChangeEvent: { __typename?: 'EmptyResult', emptyResult?: string | null | undefined } };

export type ChangeEventPageFragment = { __typename?: 'ChangeEvent', canCreateFinalEstimate: boolean, identifier: number, isReadyHomeManaged: boolean, budgetImpactInCents: number, totalCostInCents: number, status: Types.ChangeEventStatus, title: string, id: string, name: string, canSubmitForApproval: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, type: { __typename?: 'ChangeEventTypeDetail', code: Types.ChangeEventType, name: string }, lineItems: Array<{ __typename?: 'ChangeEventLineItem', id: string, originalTradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined, projectItem: { __typename?: 'ProjectItem', id: string, displayName: string, totalCostInCents: number, task?: { __typename?: 'Task', id: string, name: string, projectItems: Array<{ __typename?: 'ProjectItem', id: string }> } | null | undefined } }>, projectStage: { __typename?: 'ProjectStage', id: string, canCreateFinalEstimate: boolean, stage: { __typename?: 'StageDetail', code: Types.Stage }, project:
      | { __typename?: 'StandaloneProject', id: string, enableProductConfigPlan: boolean, features: Array<Types.ProjectFeature>, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
      | { __typename?: 'Region', id: string, enableProductConfigPlan: boolean, features: Array<Types.ProjectFeature>, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
      | { __typename?: 'Market', id: string, enableProductConfigPlan: boolean, features: Array<Types.ProjectFeature>, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
      | { __typename?: 'Community', id: string, enableProductConfigPlan: boolean, features: Array<Types.ProjectFeature>, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
      | { __typename?: 'Subdivision', id: string, enableProductConfigPlan: boolean, features: Array<Types.ProjectFeature>, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
      | { __typename?: 'Lot', id: string, enableProductConfigPlan: boolean, features: Array<Types.ProjectFeature>, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
      | { __typename?: 'Structure', id: string, enableProductConfigPlan: boolean, features: Array<Types.ProjectFeature>, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
      | { __typename?: 'Unit', id: string, enableProductConfigPlan: boolean, features: Array<Types.ProjectFeature>, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
     }, commitments: Array<
    | { __typename?: 'Commitment', id: string, accountingNumber: number, status: Types.CommitmentStatus, pandaDoc?: { __typename?: 'PandaDoc', id: string, externalPandaDocUrl?: string | null | undefined, status: Types.PandaDocStatus } | null | undefined }
    | { __typename?: 'CommitmentChangeOrder', id: string, accountingNumber: number, status: Types.CommitmentStatus, pandaDoc?: { __typename?: 'PandaDoc', id: string, externalPandaDocUrl?: string | null | undefined, status: Types.PandaDocStatus } | null | undefined }
  >, approval?: { __typename?: 'Approval', id: string } | null | undefined, tradesToDraftCommitmentsFor: Array<{ __typename?: 'TradePartner', id: string, name: string }>, pandaDoc?: { __typename?: 'PandaDoc', id: string, externalPandaDocUrl?: string | null | undefined } | null | undefined, createdBy?:
    | { __typename?: 'Bill', id: string, name: string }
    | { __typename?: 'Expense', id: string }
   | null | undefined };

export type ChangeEventPageCommitment_Commitment_Fragment = { __typename?: 'Commitment', id: string, accountingNumber: number, status: Types.CommitmentStatus, pandaDoc?: { __typename?: 'PandaDoc', id: string, externalPandaDocUrl?: string | null | undefined, status: Types.PandaDocStatus } | null | undefined };

export type ChangeEventPageCommitment_CommitmentChangeOrder_Fragment = { __typename?: 'CommitmentChangeOrder', id: string, accountingNumber: number, status: Types.CommitmentStatus, pandaDoc?: { __typename?: 'PandaDoc', id: string, externalPandaDocUrl?: string | null | undefined, status: Types.PandaDocStatus } | null | undefined };

export type ChangeEventPageCommitmentFragment =
  | ChangeEventPageCommitment_Commitment_Fragment
  | ChangeEventPageCommitment_CommitmentChangeOrder_Fragment
;

export type ChangeEventCreatedBy_Bill_Fragment = { __typename?: 'Bill', id: string, name: string };

export type ChangeEventCreatedBy_Expense_Fragment = { __typename?: 'Expense', id: string };

export type ChangeEventCreatedByFragment =
  | ChangeEventCreatedBy_Bill_Fragment
  | ChangeEventCreatedBy_Expense_Fragment
;

export const ChangeEventPageCommitmentFragmentDoc = gql`
    fragment ChangeEventPageCommitment on CommitmentLike {
  id
  accountingNumber
  status
  pandaDoc {
    id
    externalPandaDocUrl
    status
  }
}
    `;
export const ChangeEventCreatedByFragmentDoc = gql`
    fragment ChangeEventCreatedBy on ChangeEventCreatedBy {
  ... on Bill {
    id
    name
  }
  ... on Expense {
    id
  }
}
    `;
export const ChangeEventPageFragmentDoc = gql`
    fragment ChangeEventPage on ChangeEvent {
  ...Named
  canCreateFinalEstimate
  canSubmitForApproval {
    ...PotentialOperationDetails
  }
  identifier
  type {
    ...ChangeEventType
  }
  isReadyHomeManaged
  budgetImpactInCents
  totalCostInCents
  lineItems {
    id
    originalTradePartner {
      ...Named
    }
    tradePartner {
      ...Named
    }
    projectItem {
      ...AllocateProjectItems
    }
  }
  status
  title
  projectStage {
    id
    canCreateFinalEstimate
    stage {
      code
    }
    project {
      id
      enableProductConfigPlan
      features
      lotType {
        code
        clientNoun
      }
    }
  }
  commitments {
    ...ChangeEventPageCommitment
  }
  approval {
    id
  }
  tradesToDraftCommitmentsFor {
    id
    name
  }
  pandaDoc {
    id
    externalPandaDocUrl
  }
  createdBy {
    ...ChangeEventCreatedBy
  }
}
    ${NamedFragmentDoc}
${PotentialOperationDetailsFragmentDoc}
${ChangeEventTypeFragmentDoc}
${AllocateProjectItemsFragmentDoc}
${ChangeEventPageCommitmentFragmentDoc}
${ChangeEventCreatedByFragmentDoc}`;
export const ChangeEventPageDocument = gql`
    query ChangeEventPage($id: ID!) {
  changeEvent(id: $id) {
    ...ChangeEventPage
  }
}
    ${ChangeEventPageFragmentDoc}`;

/**
 * __useChangeEventPageQuery__
 *
 * To run a query within a React component, call `useChangeEventPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useChangeEventPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChangeEventPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useChangeEventPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ChangeEventPageQuery, ChangeEventPageQueryVariables> & ({ variables: ChangeEventPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ChangeEventPageQuery, ChangeEventPageQueryVariables>(ChangeEventPageDocument, options);
      }
export function useChangeEventPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ChangeEventPageQuery, ChangeEventPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ChangeEventPageQuery, ChangeEventPageQueryVariables>(ChangeEventPageDocument, options);
        }
// @ts-ignore
export function useChangeEventPageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ChangeEventPageQuery, ChangeEventPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ChangeEventPageQuery, ChangeEventPageQueryVariables>;
export function useChangeEventPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ChangeEventPageQuery, ChangeEventPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ChangeEventPageQuery | undefined, ChangeEventPageQueryVariables>;
export function useChangeEventPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ChangeEventPageQuery, ChangeEventPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ChangeEventPageQuery, ChangeEventPageQueryVariables>(ChangeEventPageDocument, options);
        }
export type ChangeEventPageQueryHookResult = ReturnType<typeof useChangeEventPageQuery>;
export type ChangeEventPageLazyQueryHookResult = ReturnType<typeof useChangeEventPageLazyQuery>;
export type ChangeEventPageSuspenseQueryHookResult = ReturnType<typeof useChangeEventPageSuspenseQuery>;
export type ChangeEventPageQueryResult = ApolloReactCommon.QueryResult<ChangeEventPageQuery, ChangeEventPageQueryVariables>;
export const DeleteChangeEventDocument = gql`
    mutation DeleteChangeEvent($input: DeleteChangeEventInput!) {
  deleteChangeEvent(input: $input) {
    emptyResult
  }
}
    `;

/**
 * __useDeleteChangeEventMutation__
 *
 * To run a mutation, you first call `useDeleteChangeEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteChangeEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteChangeEventMutation, { data, loading, error }] = useDeleteChangeEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteChangeEventMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteChangeEventMutation, DeleteChangeEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteChangeEventMutation, DeleteChangeEventMutationVariables>(DeleteChangeEventDocument, options);
      }
export type DeleteChangeEventMutationHookResult = ReturnType<typeof useDeleteChangeEventMutation>;
export type DeleteChangeEventMutationResult = ApolloReactCommon.MutationResult<DeleteChangeEventMutation>;